// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"Error_errorWrapper___B2mO"};